import { render } from "./DeductionTypesManagement.vue?vue&type=template&id=7a5f8db8&scoped=true"
import script from "./DeductionTypesManagement.vue?vue&type=script&lang=js"
export * from "./DeductionTypesManagement.vue?vue&type=script&lang=js"

import "./DeductionTypesManagement.vue?vue&type=style&index=0&id=7a5f8db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5f8db8"]])

export default __exports__